import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, Col, Modal, Row} from "reactstrap";
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import inspectionImage from 'assets/img/banner/inspection.png'
import HorizontalLine from "../Widget/HorizontalLine";
import MyCardImage from "../Card/MyCardImage";

/*= (message, okCallback, cancelCallback) =>*/
export default class ReopenVerificationConfirmModal extends BaseComponent{

    constructor(props){
        super(props);
        this.state = {
            releaseVerification:this.props.releaseVerification?this.props.releaseVerification:{}
        }
    }
    componentWillReceiveProps(props, nextContext) {
        if(this.props!==props){
            this.setState({
                releaseVerification:props.releaseVerification?props.releaseVerification:{}
            })
        }
    }


    render(){
        let {releaseVerification} = this.state
        let model = releaseVerification.model?releaseVerification.model:{}
        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="md"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <CardBody>
                            <Row>
                                <Col>
                                    <MyCardImage style={{padding:'32px',width:'80%'}} src={inspectionImage}/>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col>
                                    <h3>
                                        <strong>
                                            {model.systemType}
                                        </strong>
                                    </h3>
                                    <br/>
                                    <h5>{label.Reference}</h5>
                                    <br/>
                                    <h3>
                                        <strong>
                                            {releaseVerification.reference}
                                        </strong>
                                    </h3>
                                    <br/>
                                    <strong style={{color:'brown'}}>
                                        {label.DoYouWantToReopenThisRelease_ThisActionWillCauseTheReleaseAbleToBeTakenByAnyUser}
                                    </strong>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col style={{textAlign:'left'}}>
                                    <Button
                                        block
                                        color={"danger"}
                                        onClick={() => {
                                            this.props.onClickCancel()
                                        }}>
                                        {label.Cancel}
                                    </Button>
                                </Col>
                                <Col style={{textAlign:'right'}}>
                                    <Button
                                        block
                                        onClick={() => {
                                            this.props.onClickOk()
                                        }}>
                                        {label.ReOpenVerification}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

ReopenVerificationConfirmModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClickOk:PropTypes.func.isRequired,
    onClickCancel:PropTypes.func.isRequired,
    releaseVerification:PropTypes.object.isRequired,
}
